import React from 'react';
import { ContextActionType } from '@europrocurement/flexy-components';
import { FaOptionIcon } from '@europrocurement/l2d-icons';

const useDefaultContextActions = () => {
    const toJiraForm = (formId: string) =>
        window.open(`https://legal2digital.atlassian.net/jira/software/c/form/${formId}`, '_blank');

    const backContextActions: Array<ContextActionType> = [
        {
            name: 'Proposer une amélioration',
            icon: <FaOptionIcon icon={['fas', 'wand-magic-sparkles']} />,
            action: () => toJiraForm('fb093060-243c-4ced-81f3-97f50ce8f720'),
        },
        {
            name: 'Signaler un dysfonctionnement',
            icon: <FaOptionIcon icon={['fas', 'bug-slash']} />,
            action: () => toJiraForm('aceee865-49a3-414d-9e70-2155102ea2ba'),
        },
    ];

    const frontContextActions: Array<ContextActionType> = [
        // {
        //     name: 'Proposer une amélioration',
        //     icon: <FaOptionIcon icon={['fas', 'wand-magic-sparkles']} />,
        //     action: () => toJiraForm('6ca14a83-702d-4436-9545-37f51cb28fed'),
        // },
        // {
        //     name: 'Signaler un dysfonctionnement',
        //     icon: <FaOptionIcon icon={['fas', 'bug-slash']} />,
        //     action: () => toJiraForm('b50b05e0-7ded-4fae-a614-35656b411369'),
        // },
    ];

    return { backContextActions, frontContextActions };
};

export default useDefaultContextActions;
